import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-create-destination',
    templateUrl: './create-destination.component.html',
    styleUrl: './create-destination.component.less',
    standalone: false
})
export class CreateDestinationComponent {

  // Public
    public id?: string;
  
    // Private
    private alive = new Subject<void>();
  
    /**
     * Constructor
     */
  
    constructor(
      public dialogRef: MatDialogRef<CreateDestinationComponent>,
    ) { }
  
    /**
     * Component lifecycle
     */
  
    ngOnInit(): void {
    }
  
    ngOnDestroy(): void {
      this.alive.next();
      this.alive.complete();
    }
  
    /**
     * Methods
     */
  
    close(): void {
      this.dialogRef.close();
    }
  
    create(): void {
      if (this.id?.length) {
        this.dialogRef.close({id: this.id});
      }
    }

}
